import { render } from "./StudentQR.vue?vue&type=template&id=b72a0d32"
import script from "./StudentQR.vue?vue&type=script&lang=js"
export * from "./StudentQR.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__